import FileUploadPage from '../pages/Upload';
import AdminDashboard from '../pages/manuela';
import Form from '../pages/form';
import SearchForm from '../pages/SearchFrom';
import Columns from '../pages/columns';
import TodoManager from '../pages/planner';
import E2EEncryptedApp from '../pages/EncryptedRegister';
import MedicalIntakeForm from '../pages/PatientPage';

const adminRoutes = [
  { 
    path: '/upload', 
    element: <FileUploadPage /> 
  },
  { 
    path: '/manuela', 
    element: <AdminDashboard /> 
  },
  { 
    path: '/form', 
    element: <Form /> 
  },
  { 
    path: '/search', 
    element: <SearchForm /> 
  },
  { 
    path: '/columns', 
    element: <Columns /> 
  },
  { 
    path: '/planner', 
    element: <TodoManager /> 
  },
  { 
    path: '/encrypted', 
    element: <E2EEncryptedApp /> 
  },
  { 
    path: '/intake', 
    element: <MedicalIntakeForm /> 
  }
];

export default adminRoutes;